import React from "react";
import "./../../assets/sass/_screening.scss";
import { SnackbarProvider } from "notistack";
import TotalReviews from "./../../Components/screeningComponent/totalReviews";

function ReviewsPage() {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <TotalReviews />
        </div>
      </div>
    </SnackbarProvider>
  );
}

export default ReviewsPage;
